import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "IT Services", "Healthcare Outsourcing", "BPO Solutions", "Recruitment",
  "Business Consulting", "Data Management", "Customer Support", "Process Management",
];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="marquee"
      className="py-10 border-y border-jo-primary/10 bg-white/40 relative z-10"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="stroke-text text-4xl md:text-6xl font-extrabold tracking-tight px-8">
              {w}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-jo-highlight" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
